import { render, staticRenderFns } from "./SendDocuments.vue?vue&type=template&id=40bd12d5&"
import script from "./SendDocuments.vue?vue&type=script&lang=js&"
export * from "./SendDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SendDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports